<script setup lang="ts">
import { getApiDirectSaleDetailQueryKey, useApiDirectSaleDetail } from '~/apiClient';
import { DIRECT_SALE_DETAIL_QUERY_KEY_PREFIX } from '~/constants/queryKeyPrefix';

definePageMeta({
    key: route => `direct-sale-detail-static-${route.params.slug}`, // Prevent full page re-rendering on locale change
});

// COMPOSABLES
const { id } = useSdpParams();
const { trackViewSale } = useTracking();

// DATA
const {
    data: sale,
    error,
    isError,
    suspense,
    refetch,
} = useApiDirectSaleDetail(id, {
    query: {
        queryKey: [DIRECT_SALE_DETAIL_QUERY_KEY_PREFIX, ...getApiDirectSaleDetailQueryKey(id)],
    },
});

// Perform await only if the id is correct resolved to the path
!!id.value && (await suspense());

useSdpParamsChecker(sale, error, isError);

// LIFECYCLE
onMounted(() => {
    sale.value && trackViewSale(sale.value);
});
</script>

<template>
    <Sdp v-if="sale" :sale="sale" @refetch="refetch" />
</template>
